module.exports = __webpack_public_path__ + "static/media/icons.346e94a6.png";